var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('navbar'),_c('sidebar',{staticClass:"sidebar-container"}),_c('div',{staticClass:"main-container"},[_c('app-main',{staticClass:"app-main-container"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }